module.exports = __webpack_public_path__ + "img/5.f56b26f1.png";